/*eslint-disable*/
import api from '../'

class sentenceParsing {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/sentenceParsing/items', { params }).then(response => response.data.items);
    }
}

export default sentenceParsing;
